<template>
  <div>
    <sheet :sheetwho="'outsheet'" :tbheader="'销售单'" :sheetcolumns="columns" :sheettype="'RO'" :branchflag="'-'"></sheet>
  </div>
</template>

<script>
import sheet from './components/sheet.vue';
import { outsheetcolumns } from "@/js/sheettablecolumn";

export default {
  name:"outsheet",
  data(){
    return{
      columns:outsheetcolumns
    }
  },
  components:{
    sheet
  },
  /* mounted () {
      this.columns = outsheetcolumns;
  } */
}
</script>
<style lang="less" scoped>
/deep/.el-input {
  width: 150px;
}
/deep/.el-icon-arrow-up:before{
  content:""
}
</style>